export const reorderItems = <T>(items: T[], from: number, to: number): T[] => {
  const isOutOfRange = from < 0 || to < 0 || from >= items.length || to >= items.length;
  if (from === to || isOutOfRange) return items;

  const remaining = items.filter((_, index) => index !== from);

  return [...remaining.slice(0, to), items[from], ...remaining.slice(to)];
};
